import React, { useEffect, useState } from "react";

const ACT = [
  {
    k: "opt",
    tab: "Opticien",
    etab: "Optique Rivage",
    presta: [
      "Examen de la vue",
      "Renouvellement de lentilles",
      "Ajustement de monture",
      "Bilan visuel enfant",
      "Consultation basse vision",
    ],
    pro: ["Tous les praticiens", "Claire FONTAINE", "Marc DEVEAUX", "Léa BONNET"],
    proPick: "Claire FONTAINE",
    slots: ["09:30 - 10:15", "10:15 - 11:00", "11:00 - 11:45", "14:00 - 14:45"],
    slotPick: 2,
    pat: ["Camille", "RIVIÈRE", "camille.riviere@exemple.fr", "06 12 34 56 78"],
    msg: "Bonjour, serait-il possible de prendre rendez-vous pour un examen de la vue ? Mon ordonnance est-elle encore valide ?",
    file: "ordonnance-2024.pdf",
    fin: "Le rendez-vous s'inscrit dans la colonne de Claire FONTAINE, en Examen de la vue.",
  },
  {
    k: "aud",
    tab: "Audioprothésiste",
    etab: "Audition Rivage",
    presta: [
      "Bilan auditif personnalisé",
      "Essai d'appareillage",
      "Réglage · suivi",
      "Contrôle annuel",
      "Livraison appareils",
    ],
    pro: ["Tous les praticiens", "Samir HADDAD", "Julie REY"],
    proPick: "Samir HADDAD",
    slots: ["09:00 - 10:00", "10:15 - 11:15", "14:30 - 15:30", "16:00 - 17:00"],
    slotPick: 2,
    pat: ["Michel", "GAUTIER", "m.gautier@exemple.fr", "06 98 76 54 32"],
    msg: "Bonjour, mon appareil siffle depuis quelques jours. Serait-il possible de le faire vérifier ?",
    file: "prise-en-charge-mutuelle.pdf",
    fin: "Le rendez-vous s'inscrit dans la colonne de Samir HADDAD, en Bilan auditif.",
  },
];

const CAPS = [
  {
    t: "Il choisit sa prestation",
    d: "Vos prestations, avec vos durées. Pas de créneau générique de trente minutes pour tout le monde.",
  },
  {
    t: "Il choisit son praticien",
    d: "Ou il laisse « tous les praticiens » et prend le premier créneau libre. Dans les deux cas, le rendez-vous tombe dans la bonne colonne.",
  },
  {
    t: "Il choisit sa date",
    d: "Seuls vos jours d'ouverture s'affichent. Un dimanche soir, il réserve pour jeudi.",
  },
  {
    t: "Il prend son créneau",
    d: "Les horaires proposés sont ceux qui restent réellement libres. La confirmation puis le rappel partent tout seuls.",
  },
  {
    t: "Il laisse ses coordonnées",
    d: "Nom, e-mail, téléphone : ce sont ces informations qui alimentent la fiche, sans que personne ne les ressaisisse.",
  },
  {
    t: "Il joint son document",
    d: "Ordonnance, prise en charge, courrier : le dépôt est sécurisé et le document reste rattaché à sa fiche.",
  },
  {
    t: "C'est envoyé",
    d: "Le rendez-vous apparaît dans votre agenda, à la bonne date, chez le bon praticien, avec le document déjà là.",
  },
];

const CAL = [
  ["", "1", "2", "3", "4", "5", "6"],
  ["7", "8", "9", "10", "11", "12", "13"],
  ["14", "15", "16", "17", "18", "19", "20"],
  ["21", "22", "23", "24", "25", "26", "27"],
  ["28", "29", "30", "", "", "", ""],
];

function Chev() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="pbk-chev">
      <path d="M8 10l4-4 4 4M8 14l4 4 4-4" />
    </svg>
  );
}

function Field({ label, value, strong }) {
  return (
    <div className="pbk-f">
      <span className="pbk-lb">{label}</span>
      <div className={"pbk-in" + (strong ? " pbk-inh" : "")}>
        <span>{value}</span>
        <Chev />
      </div>
    </div>
  );
}

function Body({ i, a }) {
  if (i === 0)
    return (
      <div className="pbk-body">
        <Field label="Prestation" value={a.presta[0]} strong />
        <div className="pbk-drop">
          {a.presta.map((p, n) => (
            <div className={"pbk-op" + (n === 0 ? " pbk-opon" : "")} key={p}>
              {n === 0 ? <b>✓</b> : <b />}
              {p}
            </div>
          ))}
        </div>
      </div>
    );
  if (i === 1)
    return (
      <div className="pbk-body">
        <Field label="Prestation" value={a.presta[0]} />
        <Field label="Praticien" value={a.proPick} strong />
        <div className="pbk-drop">
          {a.pro.map((p) => (
            <div className={"pbk-op" + (p === a.proPick ? " pbk-opon" : "")} key={p}>
              {p === a.proPick ? <b>✓</b> : <b />}
              {p}
            </div>
          ))}
        </div>
      </div>
    );
  if (i === 2)
    return (
      <div className="pbk-body">
        <Field label="Prestation" value={a.presta[0]} />
        <Field label="Date souhaitée" value="11 sept. 2026" strong />
        <div className="pbk-cal">
          <div className="pbk-calh">
            <b>Septembre 2026</b>
            <span>‹ ›</span>
          </div>
          <div className="pbk-calr pbk-caldow">
            {["LUN", "MAR", "MER", "JEU", "VEN", "SAM", "DIM"].map((d) => (
              <i key={d}>{d}</i>
            ))}
          </div>
          {CAL.map((row, r) => (
            <div className="pbk-calr" key={r}>
              {row.map((d, c) => (
                <i key={r + "-" + c} className={d === "11" ? "pbk-dayon" : d === "10" ? "pbk-daynow" : ""}>
                  {d}
                </i>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  if (i === 3)
    return (
      <div className="pbk-body">
        <div className="pbk-sh">
          <b>Créneaux disponibles</b>
          <span>2026-09-11</span>
        </div>
        {a.slots.map((s, n) => (
          <div className={"pbk-slot" + (n === a.slotPick ? " pbk-sloton" : "")} key={s}>
            <b>{s}</b>
            <span>{a.proPick}</span>
          </div>
        ))}
        <div className="pbk-more">Voir plus de créneaux</div>
        <div className="pbk-res">
          <b>Résumé</b>
          <p>Service : {a.presta[0]}</p>
          <p>Créneau : 2026-09-11 · {a.slots[a.slotPick]}</p>
        </div>
      </div>
    );
  if (i === 4)
    return (
      <div className="pbk-body">
        <Field label="Prénom" value={a.pat[0]} />
        <Field label="Nom" value={a.pat[1]} />
        <Field label="E-mail" value={a.pat[2]} />
        <Field label="Téléphone" value={a.pat[3]} strong />
        <p className="pbk-hint">
          Ces informations permettent à l'établissement de vous recontacter au sujet de votre
          demande.
        </p>
        <div className="pbk-btns">
          <span className="pbk-bg">Retour</span>
          <span className="pbk-bd">Continuer</span>
        </div>
      </div>
    );
  if (i === 5)
    return (
      <div className="pbk-body">
        <span className="pbk-lb">Message</span>
        <div className="pbk-ta">{a.msg}</div>
        <span className="pbk-lb">Pièce jointe (optionnel)</span>
        <div className="pbk-file">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M14 3v5h5" />
            <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
          </svg>
          {a.file}
        </div>
        <p className="pbk-hint">Dépôt sécurisé, rattaché à votre fiche patient.</p>
        <div className="pbk-btns">
          <span className="pbk-bg">Retour</span>
          <span className="pbk-bd">Envoyer ma demande</span>
        </div>
      </div>
    );
  return (
    <div className="pbk-body pbk-done">
      <div className="pbk-ok">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M4 12.5l5 5L20 6.5" />
        </svg>
      </div>
      <b>Demande envoyée</b>
      <p className="pbk-hint">
        {a.etab} confirme le rendez-vous par SMS et par e-mail. Un rappel part la veille.
      </p>
      <div className="pbk-res">
        <b>Côté magasin</b>
        <p>{a.fin}</p>
      </div>
    </div>
  );
}

export default function PatientBooking() {
  const [act, setAct] = useState(0);
  const [i, setI] = useState(0);
  const a = ACT[act];

  useEffect(() => {
    const m = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");
    if (m && m.matches) return undefined;
    const id = setInterval(() => setI((v) => (v + 1) % CAPS.length), 3400);
    return () => clearInterval(id);
  }, [act]);

  const step = i < 4 ? 1 : i < 5 ? 2 : 3;

  return (
    <div className="pbk">
      <style>{PCSS}</style>

      <div className="pbk-tabs" role="tablist">
        {ACT.map((x, n) => (
          <button
            key={x.k}
            type="button"
            role="tab"
            aria-selected={n === act}
            className={"pbk-tab" + (n === act ? " pbk-tabon" : "")}
            onClick={() => {
              setAct(n);
              setI(0);
            }}
          >
            {x.tab}
          </button>
        ))}
      </div>

      <div className="pbk-grid">
        <div className="pbk-phwrap">
          <div className="pbk-ph">
            <div className="pbk-scr">
              <div className="pbk-status">
                <b>10:54</b>
                <span className="pbk-sig" />
              </div>
              <div className="pbk-url">ohmyvue.fr</div>
              <div className="pbk-top">
                <span className="pbk-logo">
                  <b>O</b>hmyvue
                </span>
                <span className="pbk-menu">MENU</span>
              </div>
              <div className="pbk-etab">
                {a.etab}
                <i>45150 Jargeau</i>
              </div>
              <div className="pbk-steps">
                {["Créneau", "Identification", "Pièce complémentaire"].map((s, n) => (
                  <div className={"pbk-st" + (n + 1 === step ? " pbk-ston" : "")} key={s}>
                    <b>{n + 1}</b>
                    <span>{s}</span>
                  </div>
                ))}
              </div>
              <div className="pbk-stage" key={a.k + "-" + i}>
                <Body i={i} a={a} />
              </div>
            </div>
          </div>
          <div className="pbk-dots">
            {CAPS.map((c, n) => (
              <button
                key={c.t}
                type="button"
                aria-label={c.t}
                className={"pbk-dot" + (n === i ? " pbk-doton" : "")}
                onClick={() => setI(n)}
              />
            ))}
          </div>
        </div>

        <ol className="pbk-caps">
          {CAPS.map((c, n) => (
            <li className={"pbk-cap" + (n === i ? " pbk-capon" : "")} key={c.t}>
              <b>{c.t}</b>
              <p>{c.d}</p>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
}

const PCSS = `
.pbk{margin-top:26px}
.pbk *{box-sizing:border-box}
.pbk-tabs{display:inline-flex;gap:4px;background:#EDEFF3;border-radius:999px;padding:4px;margin:0 auto 22px;
  display:flex;width:max-content}
.pbk-tab{border:0;background:transparent;font:inherit;font-size:13.4px;font-weight:600;color:#5A6478;
  border-radius:999px;padding:8px 18px;cursor:pointer}
.pbk-tabon{background:#fff;color:#0F172A;box-shadow:0 1px 3px rgba(15,23,42,.14)}

.pbk-grid{display:grid;grid-template-columns:320px 1fr;gap:34px;align-items:start}
.pbk-phwrap{display:flex;flex-direction:column;align-items:center}
.pbk-ph{width:308px;background:#0F172A;border-radius:40px;padding:9px;
  box-shadow:0 30px 60px -32px rgba(15,23,42,.6)}
.pbk-scr{background:#fff;border-radius:32px;overflow:hidden;height:596px;display:flex;flex-direction:column}
.pbk-status{display:flex;align-items:center;justify-content:space-between;background:#0F172A;
  padding:8px 18px 4px;color:#fff}
.pbk-status b{font-size:12px}
.pbk-sig{width:44px;height:10px;border-radius:3px;background:rgba(255,255,255,.55)}
.pbk-url{background:#0F172A;color:#C7CEDA;font-size:11.5px;text-align:center;padding:0 0 8px}
.pbk-top{display:flex;align-items:center;justify-content:space-between;padding:12px 16px 10px}
.pbk-logo{font-size:19px;font-weight:600;color:#0F172A;letter-spacing:-.02em}
.pbk-logo b{color:#0080FF;font-weight:700}
.pbk-menu{font-size:10.5px;font-weight:700;letter-spacing:.08em;color:#3B455C;
  border:1px solid #DDE1E8;border-radius:999px;padding:5px 11px}
.pbk-etab{padding:0 16px 10px;font-size:12.6px;font-weight:600;color:#0F172A;
  border-bottom:1px solid #EDEFF3}
.pbk-etab i{display:block;font-style:normal;font-size:10.8px;font-weight:400;color:#8A93A5;margin-top:2px}
.pbk-steps{display:flex;gap:6px;padding:12px 12px 10px}
.pbk-st{flex:1;text-align:center}
.pbk-st b{display:block;width:22px;height:22px;line-height:22px;border-radius:999px;margin:0 auto 5px;
  background:#EDEFF3;color:#8A93A5;font-size:11.5px;font-weight:700}
.pbk-st span{display:block;font-size:8.6px;font-weight:700;letter-spacing:.05em;text-transform:uppercase;
  color:#8A93A5;line-height:1.25}
.pbk-ston b{background:#0F172A;color:#fff}
.pbk-ston span{color:#0F172A}

.pbk-stage{flex:1;overflow:hidden;border-top:1px solid #EDEFF3;
  animation:pbkin .42s cubic-bezier(.22,.61,.36,1)}
@keyframes pbkin{from{opacity:0;transform:translateY(9px)}to{opacity:1;transform:none}}
@media (prefers-reduced-motion:reduce){.pbk-stage{animation:none}}
.pbk-body{padding:13px 16px;display:grid;gap:9px;align-content:start}
.pbk-f{display:grid;gap:4px}
.pbk-lb{font-size:9.6px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:#8A93A5}
.pbk-in{display:flex;align-items:center;gap:8px;border:1px solid #DDE1E8;border-radius:9px;
  padding:9px 11px;font-size:12.8px;color:#0F172A;background:#fff}
.pbk-inh{border-color:#0080FF;box-shadow:0 0 0 3px rgba(0,128,255,.14)}
.pbk-chev{width:13px;height:13px;margin-left:auto;flex:0 0 13px;stroke:#8A93A5;fill:none;stroke-width:2;
  stroke-linecap:round;stroke-linejoin:round}
.pbk-drop{border:1px solid #DDE1E8;border-radius:11px;overflow:hidden;background:#fff;
  box-shadow:0 14px 30px -18px rgba(15,23,42,.4)}
.pbk-op{display:flex;align-items:center;gap:8px;padding:9px 12px;font-size:12.6px;color:#3B455C;
  border-bottom:1px solid #F1F3F6}
.pbk-op:last-child{border-bottom:0}
.pbk-op b{width:11px;flex:0 0 11px;color:#0080FF;font-size:11px}
.pbk-opon{background:#F2F8FF;color:#0F172A;font-weight:600}

.pbk-cal{border:1px solid #DDE1E8;border-radius:11px;padding:10px}
.pbk-calh{display:flex;align-items:center;justify-content:space-between;font-size:12.4px;color:#0F172A;
  margin-bottom:8px}
.pbk-calh span{color:#8A93A5;letter-spacing:.24em}
.pbk-calr{display:grid;grid-template-columns:repeat(7,1fr);text-align:center}
.pbk-calr i{font-style:normal;font-size:11.4px;color:#3B455C;padding:4px 0;border-radius:999px}
.pbk-caldow i{font-size:8.4px;font-weight:700;letter-spacing:.04em;color:#98A1B2}
.pbk-dayon{background:#0080FF;color:#fff!important;font-weight:700}
.pbk-daynow{color:#0080FF!important;font-weight:700}

.pbk-sh{display:flex;align-items:baseline;justify-content:space-between}
.pbk-sh b{font-size:12.6px;color:#0F172A}
.pbk-sh span{font-size:10.6px;color:#8A93A5}
.pbk-slot{border:1px solid #E6E8EC;border-radius:9px;padding:8px 11px;background:#FAFBFC}
.pbk-slot b{display:block;font-size:12.6px;color:#0F172A}
.pbk-slot span{display:block;font-size:10.6px;color:#8A93A5;margin-top:1px}
.pbk-sloton{background:#EAF4FF;border-color:#9FCEFF}
.pbk-more{text-align:center;font-size:11.4px;font-weight:600;color:#0080FF;
  border:1px solid #CFE4FA;border-radius:999px;padding:6px}
.pbk-res{background:#F5F7FA;border:1px solid #E6E8EC;border-radius:10px;padding:10px 12px}
.pbk-res b{display:block;font-size:12px;color:#0F172A;margin-bottom:4px}
.pbk .pbk-res p{font-size:11.4px;color:#5A6478;line-height:1.45;margin:0}

.pbk .pbk-hint{font-size:10.8px;color:#8A93A5;line-height:1.45;margin:0}
.pbk-ta{border:1px solid #0080FF;box-shadow:0 0 0 3px rgba(0,128,255,.14);border-radius:9px;
  padding:9px 11px;font-size:12px;color:#0F172A;line-height:1.45;min-height:78px}
.pbk-file{display:flex;align-items:center;gap:8px;border:1px solid #DDE1E8;border-radius:9px;
  padding:9px 11px;font-size:12.2px;color:#0F172A;background:#fff}
.pbk-file svg{width:14px;height:14px;flex:0 0 14px;stroke:#0080FF;fill:none;stroke-width:2;
  stroke-linecap:round;stroke-linejoin:round}
.pbk-btns{display:flex;gap:9px;margin-top:3px}
.pbk-bg{flex:0 0 auto;border:1px solid #DDE1E8;border-radius:999px;padding:9px 16px;font-size:12.4px;
  font-weight:600;color:#3B455C}
.pbk-bd{flex:1;text-align:center;background:#241A4D;color:#fff;border-radius:999px;padding:9px 14px;
  font-size:12.4px;font-weight:600}
.pbk-done{text-align:center;justify-items:center;padding-top:34px;gap:11px}
.pbk-ok{width:52px;height:52px;border-radius:999px;background:#E3F7EA;display:grid;place-items:center}
.pbk-ok svg{width:24px;height:24px;stroke:#22A45D;fill:none;stroke-width:2.6;stroke-linecap:round;
  stroke-linejoin:round}
.pbk-done>b{font-size:15.5px;color:#0F172A}
.pbk-done .pbk-res{text-align:left;width:100%}

.pbk-dots{display:flex;gap:7px;margin-top:16px}
.pbk-dot{width:8px;height:8px;padding:0;border:0;border-radius:999px;background:#CBD2DD;cursor:pointer;
  transition:background .2s,width .2s}
.pbk-doton{width:22px;background:#0080FF}

.pbk-caps{list-style:none;margin:0;padding:0;display:grid;gap:8px}
.pbk-cap{border:1px solid transparent;border-radius:12px;padding:12px 15px;transition:background .18s,border-color .18s}
.pbk-cap b{font-size:14.6px;color:#8A93A5;transition:color .18s}
.pbk .pbk-cap p{font-size:13.4px;line-height:1.55;color:#98A1B2;margin:4px 0 0;transition:color .18s}
.pbk-capon{background:#fff;border-color:#E6E8EC;box-shadow:0 10px 26px -22px rgba(15,23,42,.5)}
.pbk-capon b{color:#0F172A}
.pbk .pbk-capon p{color:#5A6478}

@media (max-width:900px){
  .pbk-grid{grid-template-columns:1fr;gap:24px}
  .pbk-caps{gap:6px}
}
`;
